import React, { useCallback, useContext, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';

import { JobInformationTable } from './JobInformation';
import { AndromedaJobStatusUpdates } from './StatusUpdates';
import { useAndromeda } from '../../../modules/Andromeda';
import { SignalRHubGroupListener } from '../../../components/SignalRHubGroupListener';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    width: '100%',
    padding: '20px',
    margin: '0',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    padding: theme.spacing(2),
  },
  columns: {
    height: 'fit-content',
    width: '100%',
    display: 'flex',
    gap: theme.spacing(3),
  },
}));

export const AndromedaJobViewer = () => {
  const classes = useStyles();
  const {
    getJob,
    signalRConfig: {
      hubUrl,
      hubName,
      hubGroups: { jobUpdates: hubGroup },
    },
  } = useAndromeda();

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  const jobId = new URLSearchParams(window.location.search).get('id');

  const listeners = [
    {
      name: hubGroup.listenerMethods.updateJob,
      method: (newJob) => {
        if (newJob.id === jobId) setData(newJob);
      },
    },
  ];

  const fetchJob = useCallback(async () => {
    setLoading(true);
    const job = await getJob(jobId);
    if (!!job) setData(job);
    else setData({});
    setLoading(false);
  }, [jobId]);

  useEffect(() => {
    fetchJob();
  }, [fetchJob]);

  return (
    <>
      <SignalRHubGroupListener
        hubUrl={hubUrl}
        hubName={hubName}
        hubGroup={hubGroup}
        hubListeners={listeners}
      />
      <section className={classes.wrapper}>
        <div className={classes.content}>
          <section className={classes.columns}>
            <JobInformationTable
              active={data?.finished === null}
              data={data}
              loading={loading}
            />{' '}
            <AndromedaJobStatusUpdates
              active={data?.finished === null}
              loading={loading}
              data={data.statusUpdates}
            />
          </section>
        </div>
      </section>
    </>
  );
};
